<ng-template #titleTpl>
  <intelishs-page-header title="Documentos del Empleado" [subtitle]="subtitulo()" />
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="modalFooter"
  nzWidth="1000px"
  [nzStyle]="{ top: '24px' }"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (empleado()) {
      <div class="docs-nota">
        <nz-icon nzType="info-circle" />
        Sube, visualiza o elimina los documentos del empleado. Cada tipo admite un archivo (máx. 10
        MB); subir uno nuevo reemplaza el anterior. También puedes arrastrar el archivo sobre su
        fila.
      </div>

      <nz-spin [nzSpinning]="loading()" nzTip="Cargando documentos…">
        <!-- Una ranura por tipo. El CONJUNTO es de este módulo —los 14 tipos del
             catálogo del FileManager y la rejilla en que se acomodan—; la fila y
             todo su comportamiento vienen de la librería. -->
        <div class="docs-grid">
          @for (t of tipos; track t.id) {
            <intelishs-file-slot
              [label]="t.nombre"
              [state]="estado(t.id)"
              [fileName]="nombre(t.id)"
              loadedText="Documento cargado"
              [accept]="accept"
              [maxMb]="maxMb"
              (pick)="subir(t.id, $event[0])"
              (action)="onAccion($event, t)"
              (reject)="avisar($event)"
            />
          }
        </div>
      </nz-spin>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="sinay-outline-reset" (click)="cerrar()">Cerrar</button>
  </ng-template>
</nz-modal>
